import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rootRoute } from '../../app/routes-base';

/*
 * Public guest pages (ADR-0023): opened from a table's QR code, no sign-in. Every table has its
 * own token; all tokens of a branch show the same menu.
 */

export const guestScanRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/menu',
  component: lazyRouteComponent(() => import('./scan-page'), 'ScanPage'),
});

export const guestMenuRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/menu/t/$token',
  component: lazyRouteComponent(() => import('./menu-page'), 'GuestMenuPage'),
});

export const guestBillRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/menu/t/$token/tagihan',
  /** `bayar` = the online payment the provider sent the guest back from. */
  validateSearch: (search: Record<string, unknown>): { bayar?: string } =>
    typeof search.bayar === 'string' && /^[0-9a-f-]{36}$/i.test(search.bayar)
      ? { bayar: search.bayar }
      : {},
  component: lazyRouteComponent(() => import('./bill-page'), 'GuestBillPage'),
});

/** Hosted checkout of the payment simulator (local/staging only; the API 404s otherwise). */
export const simulatorRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/menu/bayar/simulasi/$reference',
  component: lazyRouteComponent(() => import('./simulator-page'), 'SimulatorPage'),
});

export const guestRoutes = [guestScanRoute, guestMenuRoute, guestBillRoute, simulatorRoute];
